import { Checkbox } from "@/components/Checkbox";
import { memo, useCallback } from "react";
import type { FieldRenderInputProps } from "../../types";
import { BaseField, type BaseFieldProps } from "./BaseField";

export const CheckboxField = memo(
  ({
    fieldId,
    field,
    layout,
    readOnly,
    disabled,
    className,
    "data-testid": testId,
  }: BaseFieldProps) => {
    // 入力レンダリング関数
    const renderInput = useCallback(
      (props: FieldRenderInputProps) => {
        // 値をブール型に変換
        const boolValue =
          typeof props.value === "string"
            ? props.value.toLowerCase() === "true"
            : Boolean(props.value);

        // 入力変更ハンドラー
        const handleCheckedChange = (checked: boolean) => {
          props.onChange(checked);
        };

        return (
          <div className="flex items-center p-2">
            <Checkbox
              id={props.id}
              name={props.name}
              checked={boolValue}
              onCheckedChange={
                props.disabled || props.readOnly
                  ? undefined
                  : handleCheckedChange
              }
              onFocus={props.onFocus}
              onBlur={props.onBlur}
              disabled={props.disabled}
              readOnly={props.readOnly}
              required={props.required}
              aria-invalid={!!props.error}
              aria-describedby={props.error ? `${props.id}-error` : undefined}
              label={field?.label}
              size={16}
            />
          </div>
        );
      },
      [field?.label],
    );

    // BaseFieldを使用してチェックボックスフィールドをレンダリング
    return (
      <BaseField
        fieldId={fieldId}
        field={field}
        layout={layout}
        readOnly={readOnly}
        disabled={disabled}
        className={className}
        data-testid={testId}
        renderInput={renderInput}
      />
    );
  },
);

CheckboxField.displayName = "CheckboxField";
